import _ from 'lodash';
import { useEffect } from 'react';
import NeedsManager from '@utils/NeedsManager';
import CrudPage from '@modules/cruds/CrudPage';

import { defaultConfigComponent } from './TaskTypes';

import * as yup from 'yup';
import TaskTypeForm from './TaskTypeForm';

//----------------------------------------------------------
const taskTypeDefaultAttrs = {
  successiveTask: false,
  logEventUponCreation: false,
  logEventUponStatusChange: false,
  logEventUponDecommission: false,
  logEventUponCompletion: false,
  numberOfPeople: 0,
  numberOfItems: 0,
  warningBeforeUnits: 'days',
  periodicityUnits: 'days',
};

const taskTypeSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
});

const TaskTypePage = props => {
  useEffect(() => {
    const needs = [{ url: '/api/eventTypes', dataPath: 'eventTypes' }];
    new NeedsManager(props.data, needs).fetchNeeds();
  }, []);

  const defaultValues = { taskTypeDefaultAttrs };

  return (
    <CrudPage
      key={'taskTypePage'}
      configComponent={defaultConfigComponent}
      form={TaskTypeForm}
      defaultValues={defaultValues}
      validationSchema={taskTypeSchema}
    />
  );
};

export default TaskTypePage;
